import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Skeleton from '../UI/Skeleton'

class Steps extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            skeletonSteps: [1, 2, 3, 4],
        }
    }

    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div>
                            <div className="program__going_timeline-wrapper d-flex align-items-start justify-content-center">
                                <div className="timeline__left">
                                    {
                                        this.state.skeletonSteps.map((step, index) =>
                                            index % 2 === 0 &&
                                            (
                                                <div className="timeline__card" key={`step-${index}`}>
                                                    <div className="timeline__dot"></div>
                                                    {index === this.state.skeletonSteps.length - 1 &&
                                                        <div className="timeline__patch"></div>
                                                    }
                                                    <Skeleton className="timeline__card_step xs-font-size d-block ml-auto" width={'20%'} />
                                                    <Skeleton className="timeline__card_title md-font-size d-block ml-auto" width={'30%'} />
                                                    <Skeleton className="timeline__card_text md-font-size" />
                                                    <Skeleton className="timeline__card_text md-font-size mt-0" count={2} />
                                                </div>
                                            ),
                                        )
                                    }
                                </div>
                                <div className="timeline__center ">
                                    <div className="timeline__line h-100"></div>
                                </div>
                                <div className="timeline__right">
                                    {
                                        this.state.skeletonSteps.map((step, index) =>
                                            index % 2 !== 0 &&
                                            (
                                                <div className="timeline__card" key={`step-${index}`}>
                                                    <div className="timeline__dot"></div>
                                                    {index === this.state.skeletonSteps.length - 1 &&
                                                        <div className="timeline__patch"></div>
                                                    }
                                                    <Skeleton className="timeline__card_step xs-font-size d-block mr-auto" width={'20%'} />
                                                    <Skeleton className="timeline__card_title md-font-size d-block mr-auto" width={'30%'} />
                                                    <Skeleton className="timeline__card_text md-font-size" />
                                                    <Skeleton className="timeline__card_text md-font-size mt-0" count={2} />
                                                </div>
                                            ),
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            {
                                this.props.process.length &&
                                <div className="program__going_timeline-wrapper d-flex align-items-start justify-content-center">
                                    <div className="timeline__left">
                                        {
                                            this.props.process.map((step, index) =>
                                                index % 2 === 0 &&
                                                (
                                                    <div className="timeline__card" key={`step-${index}`}>
                                                        <div className="timeline__dot"></div>
                                                        {index === this.props.process.length - 1 &&
                                                            <div className="timeline__patch"></div>
                                                        }
                                                        <span className="timeline__card_step xs-font-size">{t('catalog-step')} {index + 1}</span>
                                                        <p className="timeline__card_title md-font-size">{step.title}</p>
                                                        <p className="timeline__card_text md-font-size">{step.desc}</p>
                                                    </div>
                                                ),
                                            )
                                        }
                                    </div>
                                    {
                                        this.props.process.length > 1 &&
                                        <div className="timeline__center ">
                                            <div className="timeline__line h-100"></div>
                                        </div>
                                    }
                                    {
                                        this.props.process.length > 1 &&
                                        <div className="timeline__right">
                                            {
                                                this.props.process.map((step, index) =>
                                                    index % 2 !== 0 &&
                                                    (
                                                        <div className="timeline__card" key={`step-${index}`}>
                                                            <div className="timeline__dot"></div>
                                                            {index === this.props.process.length - 1 &&
                                                                <div className="timeline__patch"></div>
                                                            }
                                                            <span className="timeline__card_step xs-font-size">{t('catalog-step')} {index + 1}</span>
                                                            <p className="timeline__card_title md-font-size">{step.title}</p>
                                                            <p className="timeline__card_text md-font-size">{step.desc}</p>
                                                        </div>
                                                    ),
                                                )
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                }
            </React.Fragment>
        )
    }
}

Steps.propTypes = {
    t: PropTypes.func,
    process: PropTypes.array,
    skeleton: PropTypes.bool,
}

export default withTranslation()(Steps)



// WEBPACK FOOTER //
// ./src/components/Catalog/Steps.jsx